module.exports = __webpack_public_path__ + "static/media/success-icon.3e2d51a4.png";